<template>
  <LcTeaser
    v-bind="{
      badge,
    }"
    body-class="free-to-play-teaser-body"
    class="free-to-play-teaser-background-image-mystery"
    header-class="free-to-play-teaser-header"
    :header-to="primaryButtonProps.to"
  >
    <template #header>
      <img
        :alt="t('freetoplay.mysteryscratch.logo.alt')"
        src="~/assets/img/freeToPlay/logo-mystery-scratch.svg"
      />
    </template>

    <section class="w-full">
      <NuxtLink class="lc-lottery-teaser__jackpot-wrap" tabindex="-1" :to="primaryButtonProps.to">
        <strong class="lc-lottery-teaser__jackpot-text flex w-full justify-center">
          {{ t('freetoplay.mysteryscratch.headline') }}
        </strong>

        <LcLotteryJackpot v-bind="{ value: FREE_TO_PLAY_TOP_PRIZE_AMOUNT }" size="small" />

        <strong class="lc-lottery-teaser__jackpot-text w-full flex justify-center">
          {{ t('freetoplay.mysteryscratch.subline') }}
        </strong>
      </NuxtLink>
    </section>

    <section class="lc-lottery-teaser__button-container">
      <div class="lc-lottery-teaser__button-wrap">
        <LcButton
          v-bind="primaryButtonProps"
          :aria-label="t('freetoplay.mysteryscratch.button.label')"
          class="lc-lottery-teaser__button"
          no-padding
          :variant="'primary'"
        >
          {{ t('freetoplay.mysteryscratch.button.label') }}
        </LcButton>
      </div>
    </section>
  </LcTeaser>
</template>

<script lang="ts" setup>
import type { LcTeaserBadgeProps } from '@lottocom/frontend-components'

import { FREE_TO_PLAY_ROUTE, FREE_TO_PLAY_TOP_PRIZE_AMOUNT } from '../constants/constants'

const { t } = useI18n()
const route = useRoute()

const badge: LcTeaserBadgeProps = {
  title: t('freetoplay.mysteryscratch.badge.label'),
  variant: 'floating',
}

const primaryButtonProps = computed(() => ({
  ariaLabel: t('freetoplay.mysteryscratch.button.arialabel', {
    lottery: t(`freetoplay.mysteryscratch.name`),
  }),
  text: t('freetoplay.mysteryscratch.button.label'),
  to: {
    path: FREE_TO_PLAY_ROUTE,
  },
}))
</script>

<style lang="scss" scoped>
:deep(.free-to-play-teaser-body) {
  gap: 0;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: token('size/space/gap/200') 0 token('size/space/gap/400');
}

:deep(.free-to-play-teaser-header) {
  gap: token('size/space/gap/100');
  justify-content: center;
}

:deep(.lc-lottery-jackpot) {
  background: linear-gradient(
    180deg,
    #fff 15.87%,
    #9f9f9f 48.56%,
    #e7e7e7 66.83%,
    #f2f2f2 87.5%,
    #8c8c8c 100%
  );
  background-clip: text;
  color: transparent;
  text-shadow: none;
}

/* stylelint-disable-next-line selector-class-pattern */
:deep(.lc-lottery-teaser__jackpot-text) {
  color: token('color/text/primary/primary-inverted');
}
/* stylelint-disable-next-line selector-class-pattern */
:deep(.lc-lottery-teaser__button-container) {
  padding: token('size/space/gap/none') token('size/space/gap/900');
}

.free-to-play-teaser-background {
  border-radius: token('size/radius/l');
}

.free-to-play-teaser-background-image-mystery {
  background-image: url('~/assets/img/freeToPlay/background-mystery-scratch.webp');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
